const customerTaxCodeTypes = {
  shippingCredentialKr: 'shipping_credential_kr',
  taxCredentialBr: 'tax_credential_br',
  shippingCredentialCn: 'shipping_credential_cn',
  taxCredentialIt: 'tax_credential_it',
  taxEmailIt: 'tax_email_it',
  taxCredentialMx: 'tax_credential_mx',
}

export const customerTaxCodeLabels = {
  [customerTaxCodeTypes.shippingCredentialKr]: 'Código personal de aduanas (PCCC)',
  [customerTaxCodeTypes.taxCredentialBr]: 'CPF / CNPJ',
  [customerTaxCodeTypes.shippingCredentialCn]: 'Documento de identidad de residente (China)',
  [customerTaxCodeTypes.taxCredentialIt]: 'Código fiscal (CF)',
  [customerTaxCodeTypes.taxEmailIt]: 'Correo electrónico certificado (PEC)',
  [customerTaxCodeTypes.taxCredentialMx]: 'RFC (Registro Federal de Contribuyentes)',
}
